var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Button, FormControl, Grid, InputAdornment, MenuItem, Select, TextField, Typography, } from "@material-ui/core";
import { Controller } from "react-hook-form";
import { Translate as T } from "react-localize-redux";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import TermsConditions from "../commons/TermsConditions/TermsConditions";
import { useCashCheckoutState } from "./state/useCashCheckoutState";
import { Mail, User } from "react-feather";
import KPayCheck from "../commons/KPayCheck/KPayCheck";
import { defaultTo } from "lodash";
import { CountryEnum } from "../../shared/constants/CountryEnum";
import { IdentificationNumberEnum } from "../../shared/constants/IdentificationNumberEnum";
import InputMask from "react-input-mask";
import { useDocumentNumberMaskState } from "../../hooks/useDocumentNumberMaskState/useDocumentNumberMaskState";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        "&:hover": {
            backgroundColor: "#023365",
        },
        backgroundColor: "#023365",
        borderRadius: 8,
        color: "#FFF",
        height: "48px",
        "&.Mui-disabled": {
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
        },
    },
    formControl: {
        "& .MuiInputBase-root": {
            borderRadius: 8,
            color: "#6D7781",
            height: "48px",
        },
        "&. Mui-focused fieldset": {
            borderRadius: 8,
        },
        marginTop: 8,
    },
    inputRoot: {
        "& .MuiInputBase-root": {
            height: 48,
        },
    },
    textAlignCenter: {
        textAlign: "center",
    },
    textFieldRoot: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 8,
        },
        marginTop: 8,
    },
}); });
export var setRegisterRules = function (name) {
    var rules = {
        required: React.createElement(T, { id: "cashSection.fieldRequired" }),
    };
    if (name === "email")
        rules = __assign(__assign({}, rules), { pattern: {
                message: React.createElement(T, { id: "cashSection.invalidEmail" }),
                value: new RegExp("^[\\w-.]+@([\\w-]+\\.)+[\\w-]+$"),
            } });
    return __assign({}, rules);
};
export var CheckoutCash = function () {
    var _a = useCashCheckoutState(), form = _a.form, handleSubmit = _a.handleSubmit, handleTermsModal = _a.handleTermsModal, termsModal = _a.termsModal, data = _a.data;
    var classes = useStyles();
    var _b = useCheckoutContext(), country = _b.country, amount = _b.amount, handlers = _b.handlers, kpayEnable = _b.kpayEnable, readOnly = _b.readOnly, emailKpay = _b.emailKpay, enableKpay = _b.enableKpay, disablePayButton = _b.disablePayButton;
    var identificationNumberType = IdentificationNumberEnum[country];
    var dataKpaySelected = __assign({}, defaultTo(data, {
        brand: "",
        documentNumber: "",
        documentType: identificationNumberType[0].label,
        email: "",
        id: "",
        kind: "cash",
        name: "",
        firstName: "",
        lastName: "",
    }));
    var _c = useDocumentNumberMaskState(), mask = _c.mask, onSelectDocumentType = _c.onSelectDocumentType;
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: form.handleSubmit(handleSubmit) },
            React.createElement(T, null, function (_a) {
                var translate = _a.translate;
                return (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Grid, { container: true, direction: "row", spacing: 1 },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { placeholder: translate("cashSection.name"), defaultValue: dataKpaySelected.firstName, fullWidth: true, name: "name", id: "name", className: classes.textFieldRoot, variant: "outlined", margin: "normal", error: !!form.errors.name, classes: {
                                    root: classes.inputRoot,
                                }, inputRef: form.register(__assign({}, setRegisterRules("name"))), InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(User, { color: "#6D7781", size: 20 }))),
                                }, helperText: !!form.errors.name && form.errors.name.message })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { placeholder: translate("cashSection.lastName"), fullWidth: true, name: "lastName", defaultValue: dataKpaySelected.lastName, id: "lastName", className: classes.textFieldRoot, variant: "outlined", margin: "normal", error: !!form.errors.lastName, classes: {
                                    root: classes.inputRoot,
                                }, inputRef: form.register(__assign({}, setRegisterRules("lastName"))), InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(User, { color: "#6D7781", size: 20 }))),
                                }, helperText: !!form.errors.lastName && form.errors.lastName.message })),
                        country !== CountryEnum.MX && (React.createElement(Grid, { item: true, xs: 3 },
                            React.createElement(FormControl, { className: classes.formControl, fullWidth: true, margin: "normal", variant: "outlined" },
                                React.createElement(Controller, { control: form.control, name: "documentType", defaultValue: dataKpaySelected.documentType, inputRef: form.register(__assign({}, setRegisterRules("documentType"))), rules: { required: true }, render: function (_a) {
                                        var onChange = _a.onChange, value = _a.value, name = _a.name;
                                        return (React.createElement(Select, { onChange: onChange, id: name, fullWidth: true, value: value, onClick: onSelectDocumentType }, identificationNumberType.map(function (item, index) { return (React.createElement(MenuItem, { key: index, value: item.value }, item.label)); })));
                                    } })))),
                        country !== CountryEnum.MX && (React.createElement(Grid, { item: true, xs: 9 },
                            React.createElement(InputMask, { mask: mask, maskChar: null, defaultValue: dataKpaySelected.documentNumber }, function () { return (React.createElement(TextField, { placeholder: translate("cashSection.identificationNumber"), fullWidth: true, defaultValue: dataKpaySelected.documentNumber, name: "documentNumber", className: classes.textFieldRoot, variant: "outlined", margin: "normal", error: !!form.errors.documentNumber, classes: {
                                    root: classes.inputRoot,
                                }, inputRef: form.register(__assign({}, setRegisterRules("documentNumber"))), helperText: !!form.errors.documentNumber &&
                                    form.errors.documentNumber.message })); }))),
                        React.createElement(Grid, { item: true, xs: 12 }, !emailKpay && (React.createElement(TextField, { placeholder: translate("cashSection.email"), fullWidth: true, name: "email", defaultValue: dataKpaySelected.email, id: "email", className: classes.textFieldRoot, variant: "outlined", margin: "normal", classes: {
                                root: classes.inputRoot,
                            }, error: !!form.errors.email, inputRef: form.register(__assign({}, setRegisterRules("email"))), InputProps: {
                                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                    React.createElement(Mail, { color: "#CBD5E0" }))),
                            }, helperText: !!form.errors.email && form.errors.email.message }))),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TermsConditions, { form: form, open: termsModal, setOpenTerms: handleTermsModal })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Button, { disabled: readOnly || disablePayButton, variant: "outlined", color: "primary", className: classes.button, disableElevation: true, fullWidth: true, type: "submit" }, translate("cashSection.payButton"))),
                        React.createElement(Grid, { item: true, xs: 12, className: classes.textAlignCenter },
                            React.createElement(Typography, { variant: "caption" },
                                translate("cashSection.paymentOrder"),
                                " ",
                                amount.total,
                                " ",
                                amount.currency)),
                        enableKpay && (React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(KPayCheck, { isChecked: kpayEnable, handlerChange: handlers.setKpayEnable }))))));
            }))));
};
